// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/drupalUtils.ts"
);
import.meta.hot.lastModified = "1717182690463.604";
}
// REMIX HMR END

import { NodePage } from "~/@types/gen";

export function nodeIsNodePage(node: any): node is NodePage {
    return node.__typename === "NodePage" && node
}